module.exports = __webpack_public_path__ + "img/filters-page-2.a125fefb.png";